import type { Editor } from '@tiptap/core';
import { v4 as uuid } from 'uuid';
import type { PopoverService } from './popover.service';

export interface PopoverAttributes {
  id?: string;
  htmlContent: string;
  linkUrl?: string;
}

export interface EditorWithPopoverService extends Editor {
  storage: Editor['storage'] & {
    popoverService?: PopoverService;
  };
}

export function generatePopoverId(): string {
  return uuid();
}
